<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'userDetail',
})
</script>
<template>
    <a-card v-if="user">
        <div class="flex align-center ">
            <a-avatar :size="64" :src="addip(user.pic)"></a-avatar>
            <div class="margin-lr">
              <div>帐号：<span class="text-primary">{{ user.userid }}</span></div>
              <div>昵称：<span class="text-primary">{{ user.username }}</span></div>

            </div>
       </div>
       <a-divider :dashed="true" />
       <a-descriptions title="详情" class="text-bold">
        <a-descriptions-item label="状态">
          <a-badge status="success" text="正常" v-if="user.enable>0" />
          <a-badge status="error" text="锁定" v-else />
        </a-descriptions-item>
        <a-descriptions-item label="手机">{{ user.tel }}</a-descriptions-item>
        <a-descriptions-item label="类型">{{ user.usertype }}</a-descriptions-item>
        <a-descriptions-item label="注册时间">{{ user.regtime }}</a-descriptions-item>
        <a-descriptions-item label="地址">{{user.province}}{{user.city}}{{user.area}}{{user.address}}</a-descriptions-item>
      </a-descriptions>
      <a-divider :dashed="true" />
      <a-descriptions title="部门">
        <a-descriptions-item  :label="it.title" v-for="(it,i) in user.companlys" :key="i" >
          <a-tag color="#ff0000" v-if="it.type>0">管理层</a-tag>
          <a-tag color="#108ee9" v-else>员工</a-tag>
          <span>{{ it.job }}</span>
        </a-descriptions-item>
      </a-descriptions>
    </a-card>
</template>
<script setup lang="ts" name="userDetail">
import { defineProps, onMounted, reactive,ref } from 'vue'
import {addip} from '@/utils/util'
import api from '@/utils/http/service'
const user=ref<Object>({})
const props=defineProps({
  id:Number,
})
onMounted(()=>{
  if(props.id){
    api.user.getv(props.id).then(res => {
        if (res.state == 1) {
          user.value= res.data
        }
      })
  }
})
</script>
